import { render, staticRenderFns } from "./SendConfirmationEmail.vue?vue&type=template&id=4e39f63a&scoped=true"
import script from "./SendConfirmationEmail.vue?vue&type=script&lang=ts"
export * from "./SendConfirmationEmail.vue?vue&type=script&lang=ts"
import style0 from "./SendConfirmationEmail.vue?vue&type=style&index=0&id=4e39f63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e39f63a",
  null
  
)

export default component.exports